<template>
  <div class="InfoBox-root">
    <div v-if="title"  class="header">
      <slot name="titleContent">
        <img v-if="image" class="titleBg" src="@/assets/img/auth/label_hetong.png" alt="">
        <span :class="image ? 'title colorStyle' : 'title'">{{ title }}</span>
        <p v-if="showLine" class="line"></p>
      </slot>
    </div>
    <slot name="title"></slot>
    <slot>
      <a-descriptions v-bind="$attrs" class="main">
        <slot name="mainContent"></slot>
      </a-descriptions>
    </slot>
    <slot name="info"></slot>
  </div>
</template>

<script>
export default {
  name: "InfoBox",
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      default: "",
    },
    image: {
      type: Boolean,
      default: false,
    },
    showLine: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.InfoBox-root {
  padding: 32px 30px 9px 30px;
  background-color: #fff;
  border-radius: 6px;
}
.header {
  display: flex;
  align-items: center;
  line-height: 32px;
  position: relative;
  z-index: 2;
  &::before {
    content: "";
    position: absolute;
    left: -30px;
    width: 4px;
    height: 16px;
    border-radius: 2px;
    background-color: #06b880;
  }
  &>div{
    width: 100%;
  }
}
.title {
  color: #171717;
  font-size: 18px;
  font-weight: bold;
}
.colorStyle{
  color: #fff;
}
.titleBg{
  position: absolute;
  left: -30px;
  z-index: -1;
}
.line{
  width: 100%;
  height: 1px;
  border-top: 1px solid #E7E9EC;
  flex: 1;
  margin-left: 12px;
}
.main {
  margin-top: 15px;
}
::v-deep .ant-descriptions-item > span {
  vertical-align: top;
}
</style>